import vue from "vue"
import Router from 'vue-router'
import IndexView from "./components/IndexView";
import OurEarthIndex from "./components/ourEarth/Index";
import PictureIndex from "./components/picture/Index"
import GreenhouseIndex from "./components/greenhouse/Index"
import WhitePollutionIndex from "./components/whitePollution/Index"
import IntroduceView from "./components/IntroduceView";


vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "index view",
            component: IndexView
        },
        {
            path: "/ourEarth/index",
            name: "ourEarth Index view",
            component: OurEarthIndex
        },
        {
            path: "/greenhouse/index",
            name: "Greenhouse Index view",
            component: GreenhouseIndex
        },
        {
            path: "/whitePollution/index",
            name: "White Pollution Index view",
            component: WhitePollutionIndex
        },
        {
            path: "/picture/index",
            name: "Picture Index view",
            component: PictureIndex
        },
        {
            path: "/introduce",
            name: "Introduce Index view",
            component: IntroduceView
        }
    ]
})


